module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-180.bedc8f8.woff2";